import { cardWithIndexParser } from '../../../types/pokerTypes';
import { createArrayWithBracesParser, numberArrayParser, numberParser } from '../inboundParsers';
export const SHOW_ALL_IN_COMMUNITY_CARDS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'cardsWithIndexes', parser: createArrayWithBracesParser(cardWithIndexParser) },
        { name: 'newBetRound', parser: numberParser },
        { name: 'newBetSequence', parser: numberParser },
        { name: 'potAmounts', parser: numberArrayParser }
    ]
};
